module.exports = __webpack_public_path__ + "static/media/communs3.12c2b6fd.jpg";